import {useState} from 'react'

export interface MouseOverListeners {
  onMouseOver?: () => void
  onMouseLeave?: () => void
}
export type UseMouseover = [boolean, MouseOverListeners]

export const useMouseover = (): UseMouseover => {
  const [isMouseOver, setState] = useState(false)
  return [
    isMouseOver,
    {
      onMouseOver: () => {
        setState(true)
      },
      onMouseLeave: () => {
        setState(false)
      }
    }
  ]
}

interface MouseListeners extends MouseOverListeners {
  onMouseDown?: () => void
  onMouseUp?: () => void
  onMouseOut?: () => void
}

export type UseMouse = [boolean, boolean, MouseListeners]

export const useMouse = (): UseMouse => {
  const [mouseover, setMouseover] = useState(false)
  const [mousedown, setMousedown] = useState(false)
  return [
    mouseover,
    mousedown,
    {
      onMouseOver: () => {
        setMouseover(true)
      },
      onMouseLeave: () => {
        setMouseover(false)
      },
      onMouseDown: () => {
        setMousedown(true)
      },
      onMouseUp: () => {
        setMousedown(false)
      },
      onMouseOut: () => {
        setMousedown(false)
      }
    }
  ]
}
